"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const axios_1 = __importDefault(require("axios"));
const copy2clipboard_1 = __importDefault(require("../../../../../../../../common/assets/js/tsutils/copy2clipboard"));
const sleep_1 = __importDefault(require("../../../../../../../../common/assets/js/tsutils/sleep"));
const lucide_vue_next_1 = require("lucide-vue-next");
const floating_vue_1 = require("floating-vue");
let SampleProjectAssociation = class SampleProjectAssociation extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.newAssociatedSamples = [];
        this.newUnassociatedSamples = [];
        this.isLoading = false;
        this.loadingSamples = false;
        this.isCheckedAvailableSamples = false;
        this.unassociatedSamples = [];
        this.associatedSamples = [];
        // addedSampleCode: string = ''
        this.forcing = false;
        this.clipboardActive = false;
        this.status = 'associate'; // 'result'
        this.result = { success: false, message: '' };
    }
    mounted() {
        this.getUnassociatedSamples();
    }
    get hasSpecialPermision() {
        return this.user.can('tracking.gis_area.associate.force') || this.user.isITMember;
    }
    get hasSamples() {
        return (this.unassociatedSamples.length + this.associatedSamples.length) > 0;
    }
    get subtitleModal() {
        if (this.status === 'result') {
            return this.result.message;
        }
        return this.$trans('tracking.sample_project_association.subtitle');
    }
    getUnassociatedSamples() {
        const gisAreaId = this.areaSelected.area.meta.id;
        this.loadingSamples = true;
        axios_1.default.get(`/tracking/gis_area/${gisAreaId}/unassociated_samples`)
            .then((response) => {
            var _a;
            this.unassociatedSamples = (_a = response.data) === null || _a === void 0 ? void 0 : _a.map((sample) => ({
                id: sample.id,
                text: sample.code,
            })).sort((a, b) => a.text.localeCompare(b.text));
        })
            .catch(error => console.log(error))
            .finally(() => {
            this.loadingSamples = false;
        });
    }
    changeIsCheckedAvailableSamples(newValue) {
        this.isCheckedAvailableSamples = newValue;
        this.unassociatedSamples = [];
        this.associatedSamples = [];
        if (newValue) {
            this.getAvailableSamples();
        }
        else {
            this.getUnassociatedSamples();
        }
    }
    getAvailableSamples() {
        const gisAreaId = this.areaSelected.area.meta.id;
        this.loadingSamples = true;
        axios_1.default.get(`/tracking/gis_area/${gisAreaId}/available_samples`)
            .then((response) => {
            var _a;
            console.log(response);
            this.unassociatedSamples = (_a = response.data) === null || _a === void 0 ? void 0 : _a.map((sample) => ({
                id: sample.id,
                text: sample.code,
            })).sort((a, b) => a.text.localeCompare(b.text));
        })
            .catch(error => console.log(error))
            .finally(() => {
            this.loadingSamples = false;
        });
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    // addSampleCodeManually() {
    //
    //     if (!this.associatedSamples.some((item) => item.text === this.addedSampleCode.toUpperCase())) {
    //         this.associatedSamples.push({
    //                     id: Date.now().toString(),
    //                     text: this.addedSampleCode.toUpperCase(),
    //                 });
    //         this.newAssociatedSamples.push({
    //             id: Date.now().toString(),
    //             text: this.addedSampleCode.toUpperCase(),
    //         });
    //     }
    //     this.addedSampleCode = '';
    //
    // }
    onCloseModal() {
        this.forcing = false;
        this.$emit('onCloseModal');
    }
    onChangeElements(unassociatedSamples, associatedSamples) {
        this.newAssociatedSamples = associatedSamples.sort((a, b) => a.text.localeCompare(b.text));
        this.newUnassociatedSamples = unassociatedSamples.sort((a, b) => a.text.localeCompare(b.text));
    }
    goBackToAssociate() {
        this.forcing = false;
        this.status = 'associate';
    }
    async toClipboard(samples) {
        const list = samples.map(s => s.text).join('\n');
        this.clipboardActive = true;
        await (0, copy2clipboard_1.default)(list);
        await (0, sleep_1.default)(1000);
        this.clipboardActive = false;
    } // toClipboard
    associate(force = false) {
        this.isLoading = true;
        this.forcing = force;
        const gisAreaId = this.areaSelected.area.meta.id;
        const data = force
            ? {
                force: force,
                samples: this.newAssociatedSamples.map((sample) => (sample.text)),
                availableSamples: this.isCheckedAvailableSamples,
                project: this.areaSelected.project_id
            }
            : {
                samples: this.newAssociatedSamples.map((sample) => (sample.text)),
                availableSamples: this.isCheckedAvailableSamples,
                project: this.areaSelected.project_id
            };
        axios_1.default.post(`/tracking/gis_area/${gisAreaId}/samples/associate`, data)
            .then(response => {
            const data = response.data;
            this.result.success = (data.type === 'success');
            this.result.message = data.message;
            if (this.result.success) {
                this.$emit('onChangeSamplingStepStatus', 'refresh');
            }
            // console.log('Samples associated successfully', response.data);
        })
            .catch(error => {
            console.error('Failed to associate samples:', error);
            this.result.success = false;
            this.result.message = error.response.data.messages;
        })
            .finally(() => {
            this.status = 'result';
            this.isLoading = false;
        });
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], SampleProjectAssociation.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], SampleProjectAssociation.prototype, "areaSelected", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], SampleProjectAssociation.prototype, "user", void 0);
SampleProjectAssociation = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            CheckBox: bmk_ui_framework_1.CheckBox,
            Modal: bmk_ui_framework_1.Modal,
            Button: bmk_ui_framework_1.Button,
            TubeIcon: bmk_ui_framework_1.TubeIcon,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
            XRoundedIcon: bmk_ui_framework_1.XRoundedIcon,
            Loading: bmk_ui_framework_1.Loading,
            DualListSelector: bmk_ui_framework_1.DualListSelector,
            Copy: lucide_vue_next_1.Copy,
            Dropdown: floating_vue_1.Dropdown
        },
    })
], SampleProjectAssociation);
exports.default = SampleProjectAssociation;
